import React, { useEffect, useState } from "react";
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { useGoogleLogout } from "react-google-login";
import SavedProteinsSequence from "../containers/profile/SavedProteinsSequence";
import Footer from "../containers/Footer";
import SavedSequncesSection from "../containers/profile/SavedSequncesSection";
import ProductButton from "../containers/ProductButton";

const Home = () => {
  const [serverLoading, setServerLoading] = useState(true);
  const [serverStatus, setServerStatus] = useState(false);
  const [serverError, setServerError] = useState(true);
  const [jupyterPort, setJupyterPort] = useState(null);
  const [jupyterSSID, setJupyterSSID] = useState(null);
  const [jupyterToken, setJupyterToken] = useState(null);
  const [userName, setUserName] = useState(null);
  const [ssid, setSsid] = useState(null);
  const [email, setEmail] = useState(null);
  const [proteins, setProteins] = useState(null);
  const [sequnces, setSequnces] = useState(null);
  const navigate = useNavigate();

  const user = AuthService.getCurrentUser();
  // console.log("aaaa", user);
  if (!user) {
    // navigate("/login");
    window.location.href = "/notebook/login";
    // window.location.reload();
  }

  useEffect(() => {
    if (user && user.email) {
      const url = new URL(window.location.href);
      const redirect = url.searchParams.get("redirect");
      if (redirect) {
        window.location.href = redirect;
      } else {
        window.location.href = "https://310.ai/copilot/";
      }
      // axios
      //   .post(`${process.env.REACT_APP_API_URL}/profile/`, {
      //     email: user.email,
      //   })
      //   .then((res) => {
      //     // console.log("here", res.data);
      //     setProteins(res.data.proteins);
      //     setSequnces(res.data.sequnces);
      //   });
    }
  }, []);

  useEffect(() => {
    setUserName(user.name);
    // console.log(user);
    setSsid(user.ssid);
    setEmail(user.email);

    // console.log({ user });
    // if (user.ssid) {
    //   navigate(`/${user.ssid}`);
    //   window.location.reload();
    // }
    axios
      .get(`${process.env.REACT_APP_API_URL}/docker/status/${user.email}`)
      .then(function (response) {
        // console.log("hh", response.data);
        if (response.data.status === "runnig") {
          // console.log("in here");
          setUserName(user.name);
          setSsid(user.ssid);
          setServerStatus(true);
        } else {
          setServerStatus(false);
        }
        setServerLoading(false);
        setJupyterPort(response.data.port);
        setJupyterToken(response.data.JupyterToken);
        setJupyterSSID(response.data.ssid);

        // navigate(`/${user.ssid}`);
        // window.location.reload();
      })
      .catch(function (error) {
        console.log("ee", error);
        setServerError(true);
        setServerLoading(false);
      });
  }, []);

  // const { signOut, loaded } = useGoogleLogout({
  //   clientId: `612031410089-8t2urlv7s9hv5c18hflligg56ctovbdh.apps.googleusercontent.com`,
  //   jsSrc: "https://apis.google.com/js/api.js",
  // });

  const logOut = () => {
    // signOut();
    AuthService.logout();
    navigate("/login");
    window.location.reload();
  };

  const handeStopServer = () => {
    setServerLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/docker/stop/${ssid ? ssid : "b-8M7A"}`
      )
      .then((res) => {
        // console.log(res.data);
        setServerLoading(false);
        setServerStatus(false);
      });
  };

  const handleRestartServer = () => {
    setServerLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/docker/restart/${ssid}`)
      .then((res) => {
        // console.log(res.data);
        setServerLoading(false);
        if (res.data.status === "runnig") {
          setServerStatus(true);
        }
      });
  };

  return (
    <div className="w-full flex flex-col pt-14 px-3 md:px-36 bg-[#2E2F38] h-screen"></div>
  );
  return (
    <div className="w-full flex flex-col pt-14 px-3 md:px-36">
      <div className="w-full flex bg-white py-6">
        <div className="w-full flex justify-between">
          <div className="flex">
            <img
              src="/notebook/avatar.png"
              className="h-14 w-14 object-cover rounedd-full"
              alt=""
            />
            <div className="flex flex-col items-start justify-center ml-2">
              <h3 className="font-bold text-sm text-[#727272]">
                {userName ? userName : "Welcome!"}
              </h3>
              <h6 className="font-light text-xs text-[#727272]">
                {email ? email : ""}
              </h6>
            </div>
          </div>
          <div className="flex pl-5 items-center">
            <img
              src="/notebook/icons/setting.png"
              className="w-6 h-6 object-cover mx-2 hover:cursor-not-allowed"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="w-full border-b border-[#D3D6DC]"></div>
      <div className="w-full flex bg-white pt-20">
        <div className="w-full flex flex-wrap">
          {/* <ProductButton title="Jupyter Notebook" image="jupyter_logo.svg" /> */}
          {/* <ProductButton title="Words2Seq" image="word2seq.svg" /> */}
          {/* <ProductButton title="Folder" image="" /> */}
          <ProductButton
            title="Viewer"
            image="viewer.svg"
            href="https://310.ai/repo/sample/1"
            padding="p-2"
          />
          <ProductButton
            title="Atlas"
            image="atlas.svg"
            href="https://310.ai/atlas"
          />
          <ProductButton
            title="Code"
            image="code.svg"
            href="https://310.ai/drylab/tutorial/create-protein"
          />
          {/* <ProductButton title="Featurize" image="Featurize.svg" /> */}
          {/* <ProductButton title="Jupyter Notebook" image="" /> */}
          {/* <ProductButton title="Jupyter Notebook" image="" /> */}
          {/* <div className="w-full flex justify-start items-start pl-4">
            <div className="w-1/5 flex flex-col hover:cursor-pointer">
              <a href="https://310.ai/services/product">
                <div className="h-48 w-48 rounded-2xl bg-[#F81717] flex items-center justify-center">
                  <img
                    src="/notebook/icons/83.png"
                    className="w-36 object-cover"
                    alt=""
                  />
                </div>
                <h4 className="text-2xl font-semibold mt-3 pl-1">Words2Seq</h4>
                <p className="text-[#555555] leading-5 mt-3 pl-1">
                  Generate sequence
                  <br />
                  from a set of features
                </p>
              </a>
            </div>
            <div className="w-1/5 flex flex-col">
              <a href="https://310.ai/services/product-go">
                <div className="h-48 w-48 rounded-2xl bg-[#85DB18] flex items-center justify-center">
                  <img
                    src="/notebook/icons/84.png"
                    className="w-28 object-cover"
                    alt=""
                  />
                </div>
                <h4 className="text-2xl font-semibold mt-3 pl-1">Featurize</h4>
                <p className="text-[#555555] leading-5 mt-3 pl-1">
                  Predict features
                  <br />
                  from sequence
                </p>
              </a>
            </div>
          </div> */}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
